import { asyncAction } from 'lib/actionCreators'

export const tagsList = asyncAction('TAGS')
